import {Alert} from '@mui/material';
import {Link} from 'react-router-dom';

import {APP_ROUTES} from '../../../const';
import usePayment from '../../../hooks/providers/usePayment';
import UpgradeSubscriptionEmailsList from '../../contact/UpgradeSubscriptionEmailsList/UpgradeSubcriptionEmailsList';

const InsufficientSubscriptionForReportDataVolumeAlert = () => {
  const {isPartner, isGuest, alreadyUsedReportsDataVolume, reportsDataVolumeAvailable, productSubscribed, hasUnpaidInvoice} = usePayment();
  const userHasInsufficientSubscriptionForCreatingReports = reportsDataVolumeAvailable <= 0 && alreadyUsedReportsDataVolume > 0;

  const shouldDisplayAlert = userHasInsufficientSubscriptionForCreatingReports && productSubscribed && !hasUnpaidInvoice && !isGuest;

  if (!shouldDisplayAlert) return null;

  return (
    <Alert severity="error" sx={{mb: 2}}>
      {isPartner ? (
        <UpgradeSubscriptionEmailsList />
      ) : (
        <>
          Vous avez atteint la limite de votre abonnement. <Link to={APP_ROUTES.profile}>Mettez-le à niveau</Link>, ou supprimez les rapports dont vous n'avez plus besoin pour continuer à accéder à
          nos services.
        </>
      )}
    </Alert>
  );
};

export default InsufficientSubscriptionForReportDataVolumeAlert;
